import { render, staticRenderFns } from "./UniDetailFaculty.vue?vue&type=template&id=bea9e8d6&scoped=true&"
import script from "./UniDetailFaculty.vue?vue&type=script&lang=js&"
export * from "./UniDetailFaculty.vue?vue&type=script&lang=js&"
import style0 from "./UniDetailFaculty.vue?vue&type=style&index=0&id=bea9e8d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea9e8d6",
  null
  
)

export default component.exports